import React, { useState } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import NewPayment from './NewPayment'
import SelectVendor from '../layout/SelectVendor'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { MAKE_VENDOR_PAYMENT, UNPAID_BILL_ORDERS } from '../../../data/url'
import httpClient from '../../../http/HttpRequest'
import Helper from '../../../helper/Helper'
import Alert from '../../../feature/Alert'

export default function VendorPayment() {

     const { t } = useTranslation();

     const [vendor_id, setVendorId] = useState('');
     const [unpaidOrders, setUnpaidOrders] = useState([]);
     const [total, setTotal] = useState({ receivedAmount: 0, usedAmount: 0, excessAmount: 0 });
     const [other, setOther] = useState({ notes: '' });
     const [payment, setPayment] = useState({});
     const thStyle = { lineHeight: "2", verticalAlign: "center" };
     const navigate = useNavigate();
     const headers = ['date', 'number', 'amount', 'due_amount', 'payment_value'];

     const remitVendor = (data) => {
          setVendorId(data.vendor_id);
          getUnpaidOrders(data.vendor_id);
     }

     const getUnpaidOrders = async (vendor_id) => {
          const res = await httpClient.post(UNPAID_BILL_ORDERS, { vendor_id: vendor_id });
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    let data = result.data;
                    let option = [];
                    data.forEach(element => {
                         option.push({
                              date: element.bill_date,
                              order_id: element.bill_id,
                              po_number: element.bill_number,
                              pending_amount: element.pending_amount,
                              net_amount: element.net_amount,
                              payment_value: 0,
                         });
                    })
                    setUnpaidOrders(option);
               }
          }
     }

     const addPayment = (paymentDetails) => {
          let amount = parseFloat(paymentDetails.amount);
          const updatedOrders1 = unpaidOrders.map(order => {
               if (amount > 0) {
                    if (parseFloat(order.pending_amount) <= amount) {
                         amount = amount - parseFloat(order.pending_amount);
                         return { ...order, payment_value: Helper.formatNumber(order.pending_amount) };
                    } else if (parseFloat(order.pending_amount) > amount) {
                         const temp_amount = amount;
                         amount = 0;
                         return { ...order, payment_value: Helper.formatNumber(temp_amount) };
                    }
               }
               return { ...order, payment_value: 0 };
          });
          setTotal(prevTotal => ({
               ...prevTotal,
               receivedAmount: Helper.formatNumber(paymentDetails.amount),
               excessAmount: Helper.formatNumber(amount),
               usedAmount: Helper.formatNumber(parseFloat(paymentDetails.amount) - parseFloat(amount))
          }));
          setUnpaidOrders(updatedOrders1);
          setPayment(paymentDetails);
     }

     const handleBlur = (index, event) => {
          const amount = parseFloat(event.target.value);
          let remainingPayment = parseFloat(payment.amount);
          const unpaidOrders1 = unpaidOrders.map((order, i) => {
               if (i === index) {
                    if (amount <= parseFloat(order.pending_amount)) {
                         remainingPayment -= amount;
                         return { ...order, payment_value: Helper.formatNumber(amount) };
                    } else {
                         remainingPayment -= parseFloat(order.pending_amount);
                         return { ...order, payment_value: Helper.formatNumber(order.pending_amount) };
                    }
               }
               return order;
          });
          setUnpaidOrders(unpaidOrders1);
          const unpaidOrders2 = unpaidOrders.map((order, i) => {
               if (i !== index) {
                    if (parseFloat(order.pending_amount) <= remainingPayment) {
                         remainingPayment -= parseFloat(order.pending_amount);
                         return { ...order, payment_value: Helper.formatNumber(order.pending_amount) };
                    } else if (parseFloat(order.pending_amount) > remainingPayment) {
                         const tempAmount = remainingPayment;
                         remainingPayment = 0;
                         return { ...order, payment_value: Helper.formatNumber(tempAmount) };
                    }
               }
               return order;
          });
          setUnpaidOrders(unpaidOrders2);
          setTotal(prevTotal => ({
               ...prevTotal,
               excessAmount: Helper.formatNumber(remainingPayment),
               usedAmount: Helper.formatNumber(parseFloat(payment.amount) - parseFloat(remainingPayment))
          }));
     };

     const handleAmount = (index, event) => {
          const amount = parseFloat(event.target.value);
          const unpaidOrders1 = unpaidOrders.map((order, i) => {
               if (i === index) {
                    if (amount <= parseFloat(order.pending_amount)) {
                         return { ...order, payment_value: amount };
                    }
               }
               return order;
          });
          setUnpaidOrders(unpaidOrders1);
     };

     const handleInputChange = (fieldName, event) => {
          const value = event.target.value;
          const formData = { ...other };
          formData[fieldName] = value;
          setOther(formData);
     };

     const savePayment = async () => {
          if (vendor_id !== '') {
               if (Object.keys(payment).length !== 0) {
                    if (payment.mode !== '') {
                         if (parseFloat(payment.amount) > 0) {
                              const post = { customer_id: vendor_id, notes: other.notes, payment: payment, orders: unpaidOrders, total: total };
                              const res = await httpClient.post(MAKE_VENDOR_PAYMENT, post);
                              if (res.requestStatus === "OK") {
                                   const result = res.result;
                                   if (result.status === 1) {
                                        Alert.success(result.message);
                                        navigate('/root/payment');
                                   } else {
                                        Alert.failure(result.message);
                                   }
                              }
                         } else {
                              Alert.error("Payment amount is required!");
                         }
                    } else {
                         Alert.error("Save Payment before process!");
                    }
               } else {
                    Alert.error("Save Payment before process!");
               }
          } else {
               Alert.error("Select Customer");
          }
     }

     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="vendor_payment" subTitle="payment" subTitleLink="root/payment" />
                    <div className="col-lg-12 grid-margin stretch-card">
                         <div className="card">
                              <div className="card-body">
                                   <div>
                                        <SelectVendor remitVendor={remitVendor} />
                                   </div>
                                   <NewPayment onClick={addPayment} />
                                   <hr />
                                   <div>
                                        <h5 className='mb-2'>{t('unpaid_documents')}</h5>
                                        <div>
                                             <table className="text-center table table-striped table-sm table-hover">
                                                  <thead className='bg-primary text-white'>
                                                       <tr className=''>
                                                            {headers.map((header, index) => (
                                                                 <th key={index}>{t(header)}</th>
                                                            ))}
                                                       </tr>
                                                  </thead>
                                                  <tbody>
                                                       {
                                                            unpaidOrders.map((row, index) => (
                                                                 <tr key={index}>
                                                                      <td>{row.date}</td>
                                                                      <td>{row.po_number}</td>
                                                                      <td>{row.net_amount}</td>
                                                                      <td>{row.pending_amount}</td>
                                                                      <td>
                                                                           <input type='number' className='form-control form-control-sm' value={row.payment_value} onChange={(e) => handleAmount(index, e)}
                                                                                onBlur={(e) => handleBlur(index, e)} />
                                                                           <span className='text-danger'></span>
                                                                      </td>
                                                                 </tr>
                                                            ))
                                                       }
                                                  </tbody>
                                             </table>
                                        </div>
                                        <hr />
                                        <div className='row mt-3'>
                                             <div className='col-md-8'>
                                                  <label>{t('notes')}</label>
                                                  <textarea className='form-control' onChange={(e) => handleInputChange('notes', e)} value={other.notes} ></textarea>
                                             </div>
                                             <div className='col-md-4 '>
                                                  <table className='table table-sm table-borderless'>
                                                       <tbody>
                                                            {
                                                                 total.receivedAmount > 0 &&
                                                                 <tr>
                                                                      <td style={thStyle} ><strong>{t('amount_received')}</strong></td>
                                                                      <td style={thStyle} className='text-right'><strong>{total.receivedAmount}</strong></td>
                                                                 </tr>
                                                            }
                                                            {
                                                                 total.usedAmount > 0 &&
                                                                 <tr>
                                                                      <td style={thStyle} ><strong>{t('amount_used_for_payments')}</strong></td>
                                                                      <td style={thStyle} className='text-right'><strong>{total.usedAmount}</strong></td>
                                                                 </tr>
                                                            }
                                                            {
                                                                 total.excessAmount > 0 &&
                                                                 <tr>
                                                                      <td style={thStyle}><strong>{t('amount_in_excess')}</strong></td>
                                                                      <td style={thStyle} className='text-right'><strong>{total.excessAmount}</strong></td>
                                                                 </tr>
                                                            }
                                                       </tbody>
                                                  </table>
                                             </div>
                                        </div>
                                        <hr />
                                        <div className='text-center'>
                                             <button className='btn btn-primary auto_click' onClick={savePayment}>{t('save')}</button>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
